import {DataModificationsHeader} from 'audit/DataModifications';
import * as net from 'util/Net';

import {MixtureWithInstructionsGraphQL} from '../../../graphql-fragments/registry/mixtures/__generated/MixtureWithInstructionsGraphQL';
import {UpdateMixtureResponseGraphQL} from '../../../graphql-fragments/registry/mixtures/__generated/UpdateMixtureResponseGraphQL';
import {UpdateMixtureParams} from './MixtureConstants';

export async function update(
  id: string,
  data: UpdateMixtureParams,
  dataModsHeader?: DataModificationsHeader
): Promise<{mixture: UpdateMixtureResponseGraphQL}> {
  return await net.patchJSONPromise({
    url: `/1/api/mixtures/${id}`,
    data,
    extraHeaders: dataModsHeader,
  });
}

export async function initializeInstructions(
  mixtureId: string
): Promise<{mixture: MixtureWithInstructionsGraphQL}> {
  return await net.postJSONPromise({url: '/1/api/mixtures:initialize-instructions', data: {mixtureId}});
}
